"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_query_1 = require("react-query");
var react_paginate_1 = require("../../../common/react_pagination/react_paginate");
var AGgrid_table_component_1 = require("../../../common/tables/AGgrid_table_component");
var appConstants_1 = require("../../../constants/appConstants");
var table_data_1 = require("../../../constants/table_data");
var fe_services_1 = require("../fe_services");
var fe_audit_details_1 = require("./fe_audit_details");
var react_router_dom_1 = require("react-router-dom");
var fe_details_utils_1 = require("./fe_details_utils");
var custom_model_1 = require("../../../common/modal/custom_model");
var FEAuditList = function (_a) {
    var feName = _a.feName, feId = _a.feId;
    var id = (0, react_router_dom_1.useParams)().id;
    var _b = React.useState([]), auditHistoryList = _b[0], setAuditHistoryList = _b[1];
    var _c = React.useState(0), totalPageCount = _c[0], setTotalPageCount = _c[1];
    var _d = React.useState(1), pageCount = _d[0], setpageCount = _d[1];
    var _e = React.useState(0), totalCount = _e[0], setTotalCount = _e[1];
    var _f = React.useState(appConstants_1.defaultPageLimit), PageLimit = _f[0], _setPageLimit = _f[1];
    var _g = React.useState(), errorMessage = _g[0], setErrorMessage = _g[1];
    var _h = React.useState(false), showDetails = _h[0], setShowDetails = _h[1];
    var _j = React.useState(null), selectedRecordDetails = _j[0], setSelectedRecordDetails = _j[1];
    (0, react_query_1.useQuery)(['audit-history-list', id, pageCount], function () {
        return (0, fe_services_1.getFEAuditHistory)(id).then(function (response) {
            var _a;
            var pageSize = PageLimit ? parseInt(PageLimit.value.toString()) : 50;
            var count = Math.ceil(response.data.count / pageSize);
            setTotalPageCount(count);
            setAuditHistoryList((_a = response.data.records) !== null && _a !== void 0 ? _a : response.data);
            setTotalCount(response.data.count);
            return response.data;
        });
    }, {
        retry: false,
        onError: function (err) {
            setErrorMessage(err);
            setAuditHistoryList([]);
        },
        enabled: !!id,
        refetchOnWindowFocus: false,
    });
    var handlePageClick = function (data) {
        setpageCount(data.selected + 1);
    };
    var navigateToDetailsPage = function (event) {
        var transformedData = (0, fe_details_utils_1.transformObject)(event.data);
        setSelectedRecordDetails(transformedData);
        setShowDetails(true);
    };
    var handleClick = function () {
        setShowDetails(false);
    };
    return (React.createElement("div", { className: "custom-pagination-table" },
        React.createElement(AGgrid_table_component_1.default, { isSortable: true, columnDefs: table_data_1.default.FE_AUDIT_HISTORY_COLUMNS, rows: auditHistoryList, pagination: false, multiSelector: "multiselect", errorMessage: errorMessage, onRowClicked: navigateToDetailsPage }),
        React.createElement(react_paginate_1.default, { onPageChange: handlePageClick, pageCount: totalPageCount, currentPage: pageCount, total: totalCount, dataLength: auditHistoryList === null || auditHistoryList === void 0 ? void 0 : auditHistoryList.length, currentPageLimits: PageLimit === null || PageLimit === void 0 ? void 0 : PageLimit.value }),
        React.createElement(custom_model_1.default, { open: showDetails, sx: { overflowX: 'auto' }, showCloseButton: true, onClose: handleClick }, selectedRecordDetails && (React.createElement(fe_audit_details_1.default, { responseData: selectedRecordDetails, previousData: selectedRecordDetails === null || selectedRecordDetails === void 0 ? void 0 : selectedRecordDetails.previous, feName: feName, feId: feId })))));
};
exports.default = FEAuditList;
